import { memo, ReactNode } from 'react';
import cc from 'classcat';
import './index.less';

export type TDividerProps = {
  children?: ReactNode;
  className?: string;
  distance?: number;
  type?: string;
  orientation?: string;
};

export const Divider = memo(
  ({
    children,
    className = '',
    distance = 0,
    orientation = 'center',
    type = 'horizontal',
    ...props
  }: TDividerProps) => {
    const style = {
      margin: type !== 'vertical' ? `${distance}px 0` : `0 ${distance}px`
    };

    return (
      <div
        style={style}
        {...props}
        className={cc([
          'divider',
          `divider--${type}`,
          { [className]: className, [`divider--${orientation}`]: children }
        ])}
      >
        {children && <span className="divider__text">{children}</span>}
      </div>
    );
  }
);
